import { createFileRoute } from "@tanstack/react-router";

import { AuthenticationScreenContainer } from "@/components";
import { textLink } from "@/ui";

const PasswordExpired = () => {
  return (
    <AuthenticationScreenContainer animate>
      <section className="flex flex-col gap-6">
        <h1 className="text-2xl font-bold text-balance">
          It&apos;s been a while since your last login
        </h1>
        <div>
          <p>
            For security reasons, you need to reset your password to continue using EO&apos;s care
            platform.
          </p>

          <br />
          <p>We have emailed you a password reset link to continue.</p>
          <br />
          <p>
            If you have any questions, email us at{" "}
            <a className={textLink} href="mailto:support@eo.care">
              support@eo.care
            </a>
            . We&apos;re here to make sure every aspect of your EO experience is a success.
            <br />
            <br />
            Yours In Better Health, <br />
            The EO Team.
          </p>
        </div>
      </section>
    </AuthenticationScreenContainer>
  );
};

export const Route = createFileRoute("/_guest/password-expired/")({ component: PasswordExpired });
